import React, { FC, memo } from "react";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface CheckoutConfirmationHeaderProps {
  readonly onClose: () => void;
}

const CheckoutConfirmationHeader: FC<CheckoutConfirmationHeaderProps> = ({ onClose }) => {
  const thankYouHeaderText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.THANK_YOU_HEADER,
  });

  return (
    <Header testID="checkout-confirmation-header">
      <ButtonIconPlaceholder />
      <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
        {thankYouHeaderText}
      </Text>
      <ButtonIcon name="close" testID="close-button-icon" onPress={onClose} />
    </Header>
  );
};

const MemoizedCheckoutConfirmationHeader = memo(CheckoutConfirmationHeader);

export { MemoizedCheckoutConfirmationHeader as CheckoutConfirmationHeader };
